
// ── Split brand-text into visual lines, fade each in ─────────────────────────
(function splitLines() {
  const ps = document.querySelectorAll('.brand-text p, .sensory-video-overlay p');
  if (!ps.length) return;
  let globalLineIndex = 0;
  ps.forEach(p => {
    const raw = p.textContent.trim();
    const words = raw.split(/\s+/);
    p.innerHTML = words.map(w => `<span class="w">${w}</span>`).join(' ');
    const spans = Array.from(p.querySelectorAll('.w'));
    const lineGroups = [];
    spans.forEach(span => {
      const top = span.offsetTop;
      const last = lineGroups[lineGroups.length - 1];
      if (last && last.top === top) last.words.push(span);
      else lineGroups.push({ top, words: [span] });
    });
    p.innerHTML = '';
    lineGroups.forEach((group, i) => {
      const span = document.createElement('span');
      span.className = 'sentence';
      span.textContent = (i > 0 ? ' ' : '') + group.words.map(s => s.textContent).join(' ');
      span.style.transitionDelay = `${(globalLineIndex + i) * 0.45}s`;
      p.appendChild(span);
    });
    globalLineIndex += lineGroups.length;
  });
})();

// ── Header scroll reveal + scroll line hide + paragraph reveal ────────────────
const siteHeader = document.getElementById('site-header');
const scrollLine = document.querySelector('.scroll-line');
const brandText  = document.querySelector('.brand-text');
if (siteHeader) {
  const onScroll = () => {
    const past = window.scrollY >= window.innerHeight * 0.85;
    siteHeader.classList.toggle('is-scrolled', past);
    if (scrollLine) scrollLine.classList.toggle('hidden', window.scrollY > 60);
    if (brandText)  brandText.classList.toggle('is-revealed', past);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

// ── Nav overlay ───────────────────────────────────────────────────────────────
const openBtn  = document.getElementById('nav-open');
const closeBtn = document.getElementById('nav-close');
const overlay  = document.getElementById('nav-overlay');

function openNav()   { overlay.classList.add('is-open'); document.body.classList.add('is-nav-open'); document.body.style.overflow='hidden'; openBtn&&openBtn.setAttribute('aria-expanded','true'); }
function closeNav()  { overlay.classList.remove('is-open'); document.body.classList.remove('is-nav-open'); document.body.style.overflow=''; openBtn&&openBtn.setAttribute('aria-expanded','false'); }
function toggleNav() { overlay.classList.contains('is-open') ? closeNav() : openNav(); }
openBtn && openBtn.addEventListener('click', toggleNav);
closeBtn && closeBtn.addEventListener('click', closeNav);
document.addEventListener('keydown', e => { if(e.key==='Escape') closeNav(); });

// Close on link click
overlay && overlay.querySelectorAll('.nav-link').forEach(a => {
  a.addEventListener('click', closeNav);
});

// ── Accordion dropdowns ───────────────────────────────────────────────────────
document.querySelectorAll('.nav-item__trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const item = trigger.closest('.nav-item');
    const isOpen = item.classList.contains('is-open');
    // Close all others
    document.querySelectorAll('.nav-item.is-open').forEach(el => el.classList.remove('is-open'));
    // Toggle this one
    if (!isOpen) item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', !isOpen);
  });
});

// ── Cart Drawer ───────────────────────────────────────────────────────────────
const cartDrawer   = document.getElementById('cart-drawer');
const cartBackdrop = document.getElementById('cart-backdrop');
const cartCountEl  = document.getElementById('cart-count');

function fmtMoney(cents) {
  return 'RM ' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}



function renderCartDrawer(cart) {
  const n = cart.item_count;
  const headEl     = document.getElementById('cart-drawer-headline');
  const scrollEl   = document.getElementById('cart-drawer-scroll');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  if (headEl)     headEl.innerHTML = n === 0 ? 'Your cart is empty' : `<span style="margin-right:6px">${n}</span>Product${n !== 1 ? 's' : ''} in your cart`;
  if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);
  if (!scrollEl) return;
  if (cart.items.length === 0) {
    scrollEl.innerHTML = '<p style="padding:20px 12px;font-size:13px;color:#999;">No items yet.</p>';
    return;
  }
  scrollEl.innerHTML = cart.items.map(item => {
    const metaWeight = (window.__pMeta && window.__pMeta[item.product_id]) || '';
    const weightStr = item.variant_title && item.variant_title !== 'Default Title'
      ? item.variant_title
      : metaWeight;
    return `
    <div class="cart-drawer__item">
      <img class="cart-drawer__item-img" src="${item.image ? (item.image.includes('?') ? item.image + '&width=200' : item.image + '?width=200') : ''}" alt="${item.product_title}">
      <div class="cart-drawer__item-body">
        <div>
          <p class="cart-drawer__item-name">${item.product_title}</p>
          ${weightStr ? `<p class="cart-drawer__item-variant">${weightStr}</p>` : ''}
        </div>
        <div>
          <select class="cart-drawer__qty-sel" data-key="${item.key}">
            ${[1,2,3,4,5,6,7,8,9,10].map(n => `<option value="${n}"${item.quantity===n?' selected':''}>${n}</option>`).join('')}
          </select>
          <div class="cart-drawer__price-row">
            <p class="cart-drawer__item-price">${fmtMoney(item.line_price)}</p>
            <button class="cart-drawer__item-remove" data-key="${item.key}" aria-label="Remove">remove</button>
          </div>
        </div>
      </div>
    </div>`;
  }).join('');

  scrollEl.querySelectorAll('.cart-drawer__item-remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      await fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:btn.dataset.key,quantity:0})});
      const updated = await (await fetch('/cart.js')).json();
      updateCartCount(updated.item_count);
      renderCartDrawer(updated);
    });
  });
  scrollEl.querySelectorAll('.cart-drawer__qty-sel').forEach(sel => {
    sel.addEventListener('change', async () => {
      await fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:sel.dataset.key,quantity:parseInt(sel.value)})});
      const updated = await (await fetch('/cart.js')).json();
      updateCartCount(updated.item_count);
      renderCartDrawer(updated);
    });
  });
}

function updateCartCount(n) {
  if (cartCountEl) cartCountEl.textContent = n;
}

async function openCartDrawer() {
  try {
    const cart = await (await fetch('/cart.js')).json();
    renderCartDrawer(cart);
    cartDrawer && cartDrawer.classList.add('is-open');
    cartBackdrop && cartBackdrop.classList.add('is-open');
    cartDrawer && cartDrawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  } catch(e) {}
}

function closeCartDrawer() {
  cartDrawer && cartDrawer.classList.remove('is-open');
  cartBackdrop && cartBackdrop.classList.remove('is-open');
  cartDrawer && cartDrawer.setAttribute('aria-hidden','true');
  document.body.style.overflow = '';
}

cartCountEl && cartCountEl.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); });
cartBackdrop && cartBackdrop.addEventListener('click', closeCartDrawer);
const cartCloseBtn = document.getElementById('cart-drawer-close');
cartCloseBtn && cartCloseBtn.addEventListener('click', closeCartDrawer);
document.addEventListener('keydown', e => { if(e.key==='Escape') closeCartDrawer(); });

async function refreshCartDot() {
  try {
    const cart = await (await fetch('/cart.js')).json();
    updateCartCount(cart.item_count);
  } catch {}
}
refreshCartDot();

// ── Variant selection ─────────────────────────────────────────────────────────
document.querySelectorAll('.vbtn').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.variant-btns').querySelectorAll('.vbtn').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    const priceEl = document.querySelector('.product-info__price');
    if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
    const atcBtn = document.querySelector('[data-atc]');
    if (atcBtn && btn.dataset.id) {
      atcBtn.dataset.id = btn.dataset.id;
      const avail = btn.dataset.avail !== 'false';
      atcBtn.disabled = !avail;
      atcBtn.textContent = avail ? 'Add to Cart' : 'Sold Out';
    }
  });
});

// ── Quantity ──────────────────────────────────────────────────────────────────
const qMinus = document.querySelector('[data-qty="-"]');
const qPlus  = document.querySelector('[data-qty="+"]');
const qInput = document.querySelector('.qty-input');
if (qMinus && qInput) qMinus.addEventListener('click', () => { if(qInput.value>1) qInput.value--; });
if (qPlus  && qInput) qPlus.addEventListener('click',  () => { qInput.value++; });

// ── Add to cart ───────────────────────────────────────────────────────────────
const atcBtn = document.querySelector('[data-atc]');
if (atcBtn) {
  atcBtn.addEventListener('click', async e => {
    e.preventDefault();
    const id = atcBtn.dataset.id;
    const qty = qInput ? parseInt(qInput.value)||1 : 1;
    const pid = atcBtn.dataset.pid; const pdetails = atcBtn.dataset.pdetails;
    if (pid && pdetails) { window.__pMeta = window.__pMeta || {}; window.__pMeta[pid] = pdetails; }
    const orig = atcBtn.textContent;
    atcBtn.textContent='Adding…'; atcBtn.disabled=true;
    try {
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:qty})});
      atcBtn.textContent='Added';
      await refreshCartDot();
      openCartDrawer();
      setTimeout(()=>{atcBtn.textContent=orig;atcBtn.disabled=false;},2000);
    } catch { atcBtn.textContent=orig; atcBtn.disabled=false; }
  });
}

// ── Cart update ───────────────────────────────────────────────────────────────
async function cartChange(key,qty){
  await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:parseInt(qty)||0})});
  location.reload();
}
window.cartChange=cartChange;

// ── Filter 3-column ───────────────────────────────────────────────────────────
const filterTrigger = document.getElementById('filter-trigger');
const filterPanel   = document.querySelector('.filter-3col');

function activateFilterGroup(btn) {
  const group = btn.dataset.group;
  document.querySelectorAll('.f-group-btn').forEach(b => b.classList.remove('is-active'));
  document.querySelectorAll('.f-values').forEach(v => v.classList.remove('is-active'));
  btn.classList.add('is-active');
  document.querySelector(`.f-values[data-group="${group}"]`)?.classList.add('is-active');
}

if (filterTrigger && filterPanel) {
  filterTrigger.addEventListener('click', () => {
    const open = filterPanel.classList.toggle('is-open');
    filterTrigger.classList.toggle('is-open', open);
    filterTrigger.setAttribute('aria-expanded', open);
    if (open) {
      const firstGroup = filterPanel.querySelector('.f-group-btn');
      if (firstGroup) activateFilterGroup(firstGroup);
    }
  });
}

document.querySelectorAll('.f-group-btn').forEach(btn => {
  btn.addEventListener('mouseenter', () => activateFilterGroup(btn));
  btn.addEventListener('click', () => activateFilterGroup(btn));
});




// ── Collection grid toggle ────────────────────────────────────────────────────
const collGrid = document.querySelector('[data-grid]');
document.querySelectorAll('.gtoggle').forEach(btn => {
  btn.addEventListener('click', () => {
    if (!collGrid) return;
    collGrid.dataset.grid = btn.dataset.cols;
    document.querySelectorAll('.gtoggle').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  });
});

// ── Align sensory grid with footer payment link ───────────────────────────────
function alignSensoryGrid() {
  return; // disabled — Location/Hours is right-aligned via CSS instead of aligning to the footer link
  if (window.innerWidth <= 480) return;
  const paymentLink  = document.querySelector('.footer-nav a:first-child');
  const sensoryGrid  = document.querySelector('.sensory-grid');
  if (!paymentLink || !sensoryGrid) return;
  const paymentLeft  = paymentLink.getBoundingClientRect().left;
  const parentRight  = sensoryGrid.parentElement.getBoundingClientRect().right;
  const rightPad     = parseInt(getComputedStyle(sensoryGrid.parentElement).paddingRight) || 0;
  const gridRight    = parentRight - rightPad;
  const valueWidth   = Math.round(gridRight - paymentLeft);
  const labelWidth   = 140;
  sensoryGrid.style.gridTemplateColumns = `${labelWidth}px ${valueWidth}px`;
}
if (document.querySelector('.sensory-grid')) {
  alignSensoryGrid();
  window.addEventListener('resize', alignSensoryGrid);
}

// ── Sensory video carousel ────────────────────────────────────────────────────
const scCarousel = document.querySelector('.sensory-carousel');
if (scCarousel) {
  const scVideos   = Array.from(scCarousel.querySelectorAll('.sensory-video'));
  const scDots     = Array.from(document.querySelectorAll('.sensory-carousel__dot'));
  const scWrap     = document.querySelector('.sensory-video-wrap');
  const scOverlays = { 1: document.getElementById('sensory-overlay-1'), 2: document.getElementById('sensory-overlay-2') };
  let scCurrent  = 0;
  let scLocked   = false;
  let scLastTime = 0;
  const DUR      = 750;
  const COOLDOWN = 1400;

  // Init positions
  scVideos.forEach((v, i) => {
    v.style.transition = 'none';
    v.style.transform  = i === 0 ? 'translateX(0)' : 'translateX(100%)';
  });
  scVideos[0]?.play().catch(() => {});
  scDots[0]?.classList.add('is-active');

  function scGoTo(index) {
    if (scLocked || index === scCurrent || index < 0 || index >= scVideos.length) return;
    scLocked = true;
    const prev    = scCurrent;
    const forward = index > prev;
    const ease    = `transform ${DUR}ms cubic-bezier(0.4,0,0.2,1)`;

    scVideos[index].style.transition = 'none';
    scVideos[index].style.transform  = forward ? 'translateX(100%)' : 'translateX(-100%)';
    scVideos[index].offsetHeight;

    scVideos[index].style.transition = ease;
    scVideos[prev].style.transition  = ease;
    scVideos[index].style.transform  = 'translateX(0)';
    scVideos[prev].style.transform   = forward ? 'translateX(-100%)' : 'translateX(100%)';

    scDots[prev]?.classList.remove('is-active');
    scDots[index]?.classList.add('is-active');
    Object.entries(scOverlays).forEach(([i, el]) => el?.classList.toggle('is-active', +i === index));
    scVideos[prev].pause();
    scVideos[index].play().catch(() => {});
    scCurrent = index;
    scLastTime = Date.now();

    setTimeout(() => { scLocked = false; }, DUR);
  }

  // Wheel
  scWrap?.addEventListener('wheel', (e) => {
    const now = Date.now();
    const busy = scLocked || (now - scLastTime < COOLDOWN);

    if (e.deltaY > 0) {
      if (scCurrent < scVideos.length - 1) {
        e.preventDefault();
        if (!busy) scGoTo(scCurrent + 1);
      } else if (busy) {
        e.preventDefault(); // block page scroll until cooldown clears
      }
    } else if (e.deltaY < 0) {
      if (window.scrollY > 10) return;
      if (scCurrent > 0) {
        e.preventDefault();
        if (!busy) scGoTo(scCurrent - 1);
      }
    }
  }, { passive: false });

  // Touch
  let scTouchY = 0;
  scWrap?.addEventListener('touchstart', e => { scTouchY = e.touches[0].clientY; }, { passive: true });
  scWrap?.addEventListener('touchend', e => {
    const diff = scTouchY - e.changedTouches[0].clientY;
    if (diff > 40)       scGoTo(scCurrent + 1);
    else if (diff < -40) scGoTo(scCurrent - 1);
  }, { passive: true });

  // Bar clicks
  scDots.forEach((dot, i) => dot.addEventListener('click', () => scGoTo(i)));
}
